import { initializeApp } from "firebase/app";
import { getAuth  } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions} from 'firebase/functions';
// import AsyncStorage from '@react-native-async-storage/async-storage';
// import {API_KEY, AUTH_DOMAIN, PROJECT_ID, STORAGE_BUCKET, MESSAGE_SENDER_ID, APP_ID, MEASUREMENT_ID} from "@env"


export const firebaseApp = ({

  // apiKey: "AIzaSyADaX0D5ft4J1h-3_pjKui-iY_tBX6DrmE",
  // authDomain: "visadocglobal.com",
  // projectId: "visadoc-1c7a1",
  // storageBucket: "visadoc-1c7a1.appspot.com",
  // messagingSenderId: "758515798098",
  // appId: "1:758515798098:web:7c0f7084bd7a8bb7000f8b",
  // measurementId: "G-PS9FWCHZ4W"




  apiKey: "AIzaSyBIsc3U-z32doxQE98U2weK6cmDVUa6sJU",
  authDomain: "visadocglobal-d7fbd.firebaseapp.com",
  projectId: "visadocglobal-d7fbd",
  storageBucket: "visadocglobal-d7fbd.firebasestorage.app",
  messagingSenderId: "439363307917",
  appId: "1:439363307917:web:076f32ee70ff232a1355c4",
  measurementId: "G-MF30H4C6QK"

});

const app = initializeApp(firebaseApp);

// export const auth = initializeAuth(firebaseApp);

// export const auth = initializeAuth(firebaseApp, {

//   persistence: getReactNativePersistence(AsyncStorage),

// });

export const auth = getAuth(app);

export const db = getFirestore(app);

export const storage = getStorage(app);

export const functions = getFunctions(app);